<template>
  <div class="flex flex-col gap-2 h-full">
    <div class="grid grid-cols-2 gap-4" v-if="props.codes?.length > 0">
      <div
        @click="scan"
        class="flex items-center justify-center border border-dashed border-gray-300 rounded-md cursor-pointer"
        :class="{
          '!cursor-not-allowed opacity-60': !props.canUpdate,
        }"
      >
        <PlusIcon class="h-5 w-5 text-gray-500 group-hover:text-gray-900" />
      </div>
      <div
        v-for="code in props.codes"
        :key="code.id"
        class="flex flex-col items-center gap-2 p-4 border border-dashed border-gray-300 rounded-md"
      >
        <img class="" :src="code.image_url" />
        <div class="flex gap-4" v-if="props.canUpdate">
          <div
            class="bg-white p-3 border rounded-md"
            @click="assign(code.id)"
            v-if="props.scannedCode === code.id"
          >
            <SwitchHorizontalTwo class="text-gray-500" aria-hidden="true" />
          </div>
          <div
            class="bg-red-600 p-3 border rounded-md"
            @click="unassign(code.id)"
          >
            <TrashOne class="text-white" aria-hidden="true" />
          </div>
        </div>
      </div>
    </div>
    <NoResults
      v-else
      hide-button
      image="/images/empty/assets/qr_codes.svg"
      :title="t('admin.space_overview.qr_codes.empty_title')"
      :description="t('admin.space_overview.qr_codes.empty_description')"
    />
  </div>
</template>

<script setup>
import TrashOne from "@/Tailwind/Icon/TrashOne";
import PlusIcon from "@/Tailwind/Icon/PlusIcon";
import SwitchHorizontalTwo from "@/Tailwind/Icon/SwitchHorizontalTwo";
import { useI18n } from "vue-i18n";
import NoResults from "@/Tailwind/Components/ListView/NoResults.vue";
import { router } from "@inertiajs/vue3";
import route from "ziggy-js";
import { toast } from "@/SharedComponents/Toaster";

const emit = defineEmits(["assign", "scan", "close"]);
const props = defineProps({
  codes: Array,
  scannedCode: String,
  canUpdate: Boolean,
});

const { t } = useI18n();

const unassign = (id) => {
  router.delete(route("qr_code.unassign", id), {
    onFinish: () => {
      toast.success(t("toasts.qr_code.unassign_space.success"));
      emit("close");
    },
  });
};

const assign = (id) => {
  emit("assign", id);
};

const scan = () => {
  if (!props.canUpdate) {
    return;
  }

  emit("scan");
};
</script>
